import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const Impersonation = lazy(() =>
  import("@scenes/Impersonation").then((module) => ({
    default: module.Impersonation,
  }))
);

export const customerSuccessAccessNRO: NavigationRoutingObject = {
  Component: Impersonation,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "braze-tools",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("customer-success-access-sidebar-pill-menu-option", "Customer Success Access"),
  pageNameForTracking: () => "Customer Success Access",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "customer-success-access-description-nav",
      "Impersonate customer accounts to troubleshoot issues or understand unique use cases"
    ),
  icon: "nav-system-customer-success-access",
  getDeveloperNavigationAllowed: ({ canImpersonate }) => {
    return canImpersonate;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("customer-success-access-nro-additional-keyword-impersonate", "Impersonate"),
        t("customer-success-access-nro-additional-keyword-impersonation", "Impersonation"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
